import { get } from 'lodash';
import React from 'react';
import { OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import WarningIcon from 'src/components/Icon/Warning';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { ResponsiveAnimation } from 'src/components/Modules/Components';
import ModuleStyle from 'src/components/Modules/Components/ModuleStyle';
import { moduleStyleProps } from 'src/components/Modules/Components/ModuleStyle/tools';
import Switcher from 'src/components/SectionSwitcher';
import {
  // optionsToNum,
  // generateLinkImg,
  generateResponsiveImage,
  responsivePosterTypeDict,
} from 'src/constrains/DraggableModules/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import {
  EModuleWidth,
  ENewTabLayerType,
  EResponsiveCarouselModuleSwitcherType,
  EResponsivePosterGap,
  EResponsivePosterType,
  EResponsiveResizingOption,
} from 'src/types/common/module';
import css from './css.module.less';

const Option = OriSelect.Option;

const ResponsivePoster = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //console.log(props);
  const {
    images,
    // onItemAdd,
    // onItemDelete,
    onItemReselect,
    onItemSort,
    onStaticChange,
    onOpenNewTab,
    specificError,
    staticData,
    breakpoint,
    animations,
    hoverAnimations,
    isConvertible,
  } = props;

  const isPc = EPreviewSize.WIDE === breakpoint;
  const isTablet = [EPreviewSize.TABLET].includes(breakpoint);
  const isMobile = [EPreviewSize.MOBILE].includes(breakpoint);
  //console.log(isPc, isTablet, isMobile);

  //console.log('specificError', specificError);
  const { layers } = specificError;
  const layersHasError = !!Object.values(layers).find((i) => i);
  //const imageLayerError=
  const posterType = get(staticData, 'posterType');
  const isOnePoster = posterType === EResponsivePosterType.ONE;
  const moduleWidth = get(staticData, 'moduleWidth');
  const posterGap = get(staticData, 'posterGap');
  const resizingOption = get(staticData, 'resizingOption');
  const draggableId = get(staticData, 'draggableId');
  const animation = get(staticData, 'animation');
  const moduleStyle = get(staticData, 'moduleStyle');

  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;

  const handleOnGapChange = (posterGap) => {
    onStaticChange({ posterGap });
  };

  const handleOnPosterTypeChange = (posterType) => {
    const dict = responsivePosterTypeDict;
    const currentHave = (images || []).length;
    const currentShouldHave = dict[posterType] || currentHave;
    if (posterType === EResponsivePosterType.ONE && (isTablet || isMobile)) {
      onStaticChange({ posterType, posterGap: EResponsivePosterGap.NONE });
    } else if (
      posterType === EResponsivePosterType.SIX &&
      posterGap === EResponsivePosterGap.LARGE &&
      isTablet
    ) {
      onStaticChange({ posterType, posterGap: EResponsivePosterGap.NONE });
    } else if (
      isMobile &&
      [
        EResponsivePosterType.FOUR,
        EResponsivePosterType.FIVE,
        EResponsivePosterType.SIX,
      ].includes(posterType) &&
      (posterGap === EResponsivePosterGap.MIDDLE ||
        posterGap === EResponsivePosterGap.LARGE)
    ) {
      onStaticChange({ posterType, posterGap: EResponsivePosterGap.NONE });
    } else {
      onStaticChange({ posterType });
    }

    if (currentShouldHave > currentHave) {
      const diff = currentShouldHave - currentHave;
      const _new = [];
      for (let i = 0; i < diff; i++) {
        const index = i + currentHave + 1;
        _new.push(generateResponsiveImage(`Poster ${index}`));
      }
      const _images = [...(images || []), ..._new];
      onItemReselect(_images);
    }
    if (currentShouldHave < currentHave) {
      const _images = images.slice(0, currentShouldHave);
      if (onItemReselect) {
        onItemReselect(_images);
      }
    }
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnResizingOptionChange = (resizingOption) => {
    onStaticChange({ resizingOption });
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  // const handleOnItemAdd = () => {
  //   if (onItemAdd) {
  //     //const item = generateResponsiveImage();
  //     //console.log('item', item);
  //     onItemAdd();
  //   }
  // };

  const handleOnEdit = (id, data, displayError) => {
    const _data = { ...data };
    // if (displayError) {
    //   _data.isNew = false;
    // }
    //const _data={...data,}
    onOpenNewTab({
      imageId: id,
      data: _data,
      contentListId: draggableId,
      type: ENewTabLayerType.Poster,
    });
  };

  const handleItemOnSort = (from, to) => {
    if (onItemSort) {
      onItemSort(from, to);
    }
  };

  // const handleOnItemDelete = (index) => {
  //   if (onItemDelete) {
  //     onItemDelete(index);
  //   }
  // };

  const renderPosterType = () => {
    //isTablet
    return [
      <Option key={EResponsivePosterType.ONE} value={EResponsivePosterType.ONE}>
        {getI18n('general.onePoster')}
      </Option>,
      <Option
        key={EResponsivePosterType.TWO_1_1}
        value={EResponsivePosterType.TWO_1_1}>
        {getI18n('general.twoInOne')} (1:1)
      </Option>,
      <Option
        key={EResponsivePosterType.TWO_1_2}
        value={EResponsivePosterType.TWO_1_2}>
        {getI18n('general.twoInOne')} (1:2)
      </Option>,
      <Option
        key={EResponsivePosterType.TWO_2_1}
        value={EResponsivePosterType.TWO_2_1}>
        {getI18n('general.twoInOne')} (2:1)
      </Option>,
      <Option
        key={EResponsivePosterType.THREE}
        value={EResponsivePosterType.THREE}>
        {getI18n('general.threeInOne')}
      </Option>,
      <Option
        key={EResponsivePosterType.FOUR}
        value={EResponsivePosterType.FOUR}>
        {getI18n('general.fourInOne')}
      </Option>,
      <Option
        key={EResponsivePosterType.FIVE}
        value={EResponsivePosterType.FIVE}>
        {getI18n('general.fiveInOne')}
      </Option>,
      <Option key={EResponsivePosterType.SIX} value={EResponsivePosterType.SIX}>
        {getI18n('general.sixInOne')}
      </Option>,
    ];
  };

  const hideGapMiddle =
    isMobile &&
    [
      EResponsivePosterType.FOUR,
      EResponsivePosterType.FIVE,
      EResponsivePosterType.SIX,
    ].includes(posterType);

  const hideGapLarge =
    isMobile || (isTablet && posterType === EResponsivePosterType.SIX);

  const renderPosterGapType = () => {
    return [
      <Option value={EResponsivePosterGap.NONE} key={EResponsivePosterGap.NONE}>
        {getI18n('general.status.none')}
      </Option>,
      <Option
        value={EResponsivePosterGap.SMALL}
        key={EResponsivePosterGap.SMALL}>
        {getI18n('general.small')}
      </Option>,
      ...(hideGapMiddle
        ? []
        : [
            <Option
              value={EResponsivePosterGap.MIDDLE}
              key={EResponsivePosterGap.MIDDLE}>
              {getI18n('general.middle')}
            </Option>,
          ]),
      ...(!hideGapLarge
        ? [
            <Option
              value={EResponsivePosterGap.LARGE}
              key={EResponsivePosterGap.LARGE}>
              {getI18n('general.lLarge')}
            </Option>,
          ]
        : []),
    ];
  };

  return (
    <React.Fragment>
      <Section size='small' bottomBorder className={css.container}>
        <ItemWrapper title={getI18n('general.posterType')}>
          <OriSelect
            size='large'
            value={posterType}
            onChange={handleOnPosterTypeChange}>
            {renderPosterType()}
          </OriSelect>
        </ItemWrapper>
        <ItemWrapper title={getI18n('general.moduleWidth')}>
          <OriSelect
            size='large'
            value={moduleWidth}
            onChange={handleOnModuleWidthChange}>
            <Option value={EModuleWidth.FULL}>
              {getI18n('general.fullWidth')}
            </Option>
            <Option value={EModuleWidth.WIDE}>
              {getI18n('general.wideWidth')}
            </Option>
            {isConvertible ? null : (
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            )}
          </OriSelect>
        </ItemWrapper>
      </Section>
      <Section size='small' bottomBorder>
        {!isOnePoster && (
          <ItemWrapper title='Gap'>
            <OriSelect
              size='large'
              value={posterGap}
              onChange={handleOnGapChange}>
              {renderPosterGapType()}
            </OriSelect>
          </ItemWrapper>
        )}
        <ItemWrapper title='Responsive Resizing Option'>
          <OriSelect
            size='large'
            value={resizingOption}
            onChange={handleOnResizingOptionChange}>
            <Option value={EResponsiveResizingOption.SCALABLE}>
              {getI18n('general.scaleHeightBasedOnModuleWidth')}
            </Option>
            <Option value={EResponsiveResizingOption.FIXED}>
              {getI18n('general.fixedHeight')}
            </Option>
          </OriSelect>
        </ItemWrapper>
      </Section>
      <Section size='small' className={css.switcherContainer}>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ModuleStyle
                    {...moduleStyleProps(moduleWidth)}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                    isMobileOrTablet={isMobile || isTablet}
                  />
                </div>
              ),
            },
            ...(isPc
              ? {
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                }
              : {}),
            [EResponsiveCarouselModuleSwitcherType.Image]: {
              title: getI18n('general.checkImgDraggableDisplay.title'),
              hasError: layersHasError,
              child: (
                <Images
                  error={layers || {}}
                  data={images}
                  onSort={handleItemOnSort}
                  // onDelete={handleOnItemDelete}
                  // onDuplicate={() => {
                  //   console.log('duplicate');
                  // }}
                  onEdit={handleOnEdit}
                  // onAdd={handleOnItemAdd}
                  draggableId={draggableId}
                  isMobileOrTablet={isMobile || isTablet}
                />
              ),
            },
          }}
        />
      </Section>
    </React.Fragment>
  );
};
export default ResponsivePoster;

// const Animation = (props) => {
//   const { data, onChange, animations } = props;
//   const _animations = [
//     { value: null, label: 'None' },
//     ...(animations || []).map((i) => {
//       const { name, uuid } = i;
//       return { label: name, value: uuid };
//     }),
//   ];
//   const entranceUuid = get(data, 'entranceUuid') || null;
//   const hoverEffectUuid = get(data, 'hoverEffectUuid') || null;
//   return (
//     <React.Fragment>
//       <ItemWrapper size='small' title='Entrance Animation'>
//         <OriSelect
//           size='large'
//           value={entranceUuid}
//           onChange={(entranceUuid) => {
//             onChange({ entranceUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//       <ItemWrapper size='small' title='Hover Effect'>
//         <OriSelect
//           size='large'
//           value={hoverEffectUuid}
//           onChange={(hoverEffectUuid) => {
//             onChange({ hoverEffectUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//     </React.Fragment>
//   );
// };
const Images = (props) => {
  const {
    data,
    onSort,
    // onDelete, // onDuplicate,
    onEdit,
    // onAdd,
    draggableId,
    error,
    isMobileOrTablet,
  } = props;
  const hasError = error[draggableId];
  const handleOnChildGenerate = (data, index) => {
    const { name, draggableId } = data;
    // console.log('data1', data);
    return (
      <TextAndEditIcon
        containerClassName={css.containerClassName}
        additional={
          hasError ? (
            <div className={css.errorIconContainer}>
              <WarningIcon />
            </div>
          ) : null
        }
        name={name}
        onClick={() => {
          if (onEdit) onEdit(draggableId, data, hasError);
        }}
      />
    );
  };
  const handleOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onSort(oldIndex, newIndex);
  };
  return (
    <DragNDropColumns
      disabled={isMobileOrTablet}
      // disabled={!isPrimary}
      // hideAdd={!isPrimary}
      hideAdd
      hideTitle
      childGenerate={handleOnChildGenerate}
      data={data}
      droppableId={`salesChannelContentListResponsivePoster${draggableId}`}
      onSort={handleOnSort}
      // hideAdd={hideAdd}
      //onAdd={onAdd}
      //addText={'+ Add Image'}
      //onDelete={onDelete}
    />
  );
};
